/* eslint-disable react/prop-types */
import React from 'react';
import { Modal } from 'semantic-ui-react';
import IconSetting from 'Assets/images/pages/web-chat/browser-settings.png';
import IconCamMicSetting from 'Assets/images/pages/web-chat/cam-mic.png';

import css from './NoPermission.less';

function NoPermission({ onClose }) {
  return (
    <Modal
      open
      content={
        <div className={css.container}>
          <div className={css.title}>
            <b>Cannot initiate a call, because camera or microphone is blocked</b>
          </div>
          <div className={css.content}>
            If you wish to join a video tele-consult via your browser, you must grant camera and
            microphone access.
          </div>
          <div className={css.content}>
            To do this, click the <img src={IconSetting} alt="settings" /> icon in your browser's
            address bar and enable the switch.
          </div>
          <img className={css.guideImg} src={IconCamMicSetting} alt="blocked" />
        </div>
      }
      actions={[{ key: 'close', content: 'Dismiss', onClick: onClose }]}
    />
  );
}

export default NoPermission;
